var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalandar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 55,
    viewBox: "0 0 59 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86667 54.2667H53.6C56.3333 54.2667 58.4667 52.0667 58.4667 49.4V7.86667C58.4667 5.13333 56.2667 3 53.6 3H4.86667C2.13333 3 0 5.2 0 7.86667V49.3333C0 52.0667 2.2 54.2667 4.86667 54.2667Z",
    fill: "#FFF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5333 7.66672V17.7334H0V7.66672C0 5.06672 2.13333 3.00006 4.66667 3.00006H53.8C56.4 2.93339 58.5333 5.06672 58.5333 7.66672Z",
    fill: "#F47C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 12.7334C16.5255 12.7334 17.6 11.6588 17.6 10.3333C17.6 9.00787 16.5255 7.93335 15.2001 7.93335C13.8746 7.93335 12.8 9.00787 12.8 10.3333C12.8 11.6588 13.8746 12.7334 15.2001 12.7334Z",
    fill: "#D66767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2667 12.7334C30.5922 12.7334 31.6667 11.6588 31.6667 10.3333C31.6667 9.00787 30.5922 7.93335 29.2667 7.93335C27.9412 7.93335 26.8667 9.00787 26.8667 10.3333C26.8667 11.6588 27.9412 12.7334 29.2667 12.7334Z",
    fill: "#D66767"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 12.7334C44.6588 12.7334 45.7333 11.6588 45.7333 10.3333C45.7333 9.00787 44.6588 7.93335 43.3333 7.93335C42.0079 7.93335 40.9333 9.00787 40.9333 10.3333C40.9333 11.6588 42.0079 12.7334 43.3333 12.7334Z",
    fill: "#D66767"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8667 0H14.5334C14.1334 0 13.8 0.333334 13.8 0.733334V10C13.8 10.4 14.1334 10.7333 14.5334 10.7333H15.8667C16.2667 10.7333 16.6 10.4 16.6 10V0.800001C16.6667 0.333334 16.2667 0 15.8667 0Z",
    fill: "#FFF2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9334 0H28.6C28.2 0 27.8667 0.333334 27.8667 0.733334V10C27.8667 10.4 28.2 10.7333 28.6 10.7333H29.9334C30.3334 10.7333 30.6667 10.4 30.6667 10V0.800001C30.6667 0.333334 30.3334 0 29.9334 0Z",
    fill: "#FFF2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H42.6667C42.2667 0 41.9333 0.333334 41.9333 0.733334V10C41.9333 10.4 42.2667 10.7333 42.6667 10.7333H44C44.4 10.7333 44.7333 10.4 44.7333 10V0.800001C44.7333 0.333334 44.4 0 44 0Z",
    fill: "#FFF2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5333 24.4667H10.8C10.1333 24.4667 9.59998 25 9.59998 25.6667V31.4C9.59998 32.0667 10.1333 32.6 10.8 32.6H16.5333C17.2 32.6 17.7333 32.0667 17.7333 31.4V25.6667C17.8 25.0667 17.2666 24.4667 16.5333 24.4667Z",
    fill: "#87A9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1333 24.4667H26.4C25.7333 24.4667 25.2 25 25.2 25.6667V31.4C25.2 32.0667 25.7333 32.6 26.4 32.6H32.1333C32.8 32.6 33.3333 32.0667 33.3333 31.4V25.6667C33.4 25.0667 32.8 24.4667 32.1333 24.4667Z",
    fill: "#87A9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7333 24.4667H41.9999C41.3333 24.4667 40.7999 25 40.7999 25.6667V31.4C40.7999 32.0667 41.3333 32.6 41.9999 32.6H47.7333C48.3999 32.6 48.9333 32.0667 48.9333 31.4V25.6667C48.9333 25.0667 48.3999 24.4667 47.7333 24.4667Z",
    fill: "#87A9FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5333 39.6H10.8C10.1333 39.6 9.59998 40.1333 9.59998 40.8V46.5333C9.59998 47.2 10.1333 47.7333 10.8 47.7333H16.5333C17.2 47.7333 17.7333 47.2 17.7333 46.5333V40.8C17.8 40.1333 17.2666 39.6 16.5333 39.6Z",
    fill: "#87A9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1333 39.6H26.4C25.7333 39.6 25.2 40.1333 25.2 40.8V46.5333C25.2 47.2 25.7333 47.7333 26.4 47.7333H32.1333C32.8 47.7333 33.3333 47.2 33.3333 46.5333V40.8C33.4 40.1333 32.8 39.6 32.1333 39.6Z",
    fill: "#87A9FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7333 39.6H41.9999C41.3333 39.6 40.7999 40.1333 40.7999 40.8V46.5333C40.7999 47.2 41.3333 47.7333 41.9999 47.7333H47.7333C48.3999 47.7333 48.9333 47.2 48.9333 46.5333V40.8C48.9333 40.1333 48.3999 39.6 47.7333 39.6Z",
    fill: "#87A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalandar);
export default __webpack_public_path__ + "static/media/calandar.7aae6c6417820a5c40fef1df4081e110.svg";
export { ForwardRef as ReactComponent };